"use client";
//#region packages/@mantine/core/src/core/utils/camel-to-kebab-case/camel-to-kebab-case.ts
function camelToKebabCase(value) {
	return value.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}
//#endregion
export { camelToKebabCase };

//# sourceMappingURL=camel-to-kebab-case.mjs.map